import React, { useEffect, useState } from 'react';

interface AuthInitializerProps {
  children: React.ReactNode;
}

export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        // Clear any old cached data that might cause issues
        const currentVersion = '1.0.1'; // Increment this to force cache clear
        const storedVersion = localStorage.getItem('app-version');
        
        if (storedVersion !== currentVersion) {
          console.log('Clearing old cache due to version mismatch');
          localStorage.removeItem('auth-store');
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.setItem('app-version', currentVersion);
        }
        
        // Give Zustand persist some time to rehydrate
        await new Promise(resolve => setTimeout(resolve, 100));
        setIsInitialized(true);
      } catch (error) {
        console.error('AuthInitializer - Error during initialization:', error);
        setIsInitialized(true); // Still initialize to prevent infinite loading
      }
    };

    initializeAuth();
  }, []);

  if (!isInitialized) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4efe2' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 48, height: 48, borderRadius: '50%', border: '2px solid transparent', borderTopColor: '#d97706', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: '#6b6a5c' }}>Initializing...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};